import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;

  .BillingAddressFieldset-row {
    display: flex;
    gap: ${spacing(3)};
  }

  /* City / State / ZIP share a row. The province control is a dropdown whose
     chevron eats width, so a zero min-width truncated its value ("New Y…").
     Give every column a real floor and let the row wrap instead. */
  .BillingAddressFieldset-row {
    flex-wrap: wrap;
  }

  .BillingAddressFieldset-row > * {
    flex: 1 1 8rem;
    min-width: 8rem;
  }

  @media (max-width: 600px) {
    .BillingAddressFieldset-row {
      flex-direction: column;
    }
  }

  /* The disclosure already titles this section "Billing address"; a visible
     legend repeated it. Kept in the a11y tree, off the screen. */
  .BillingAddressFieldset-legend {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`
